module.exports = __webpack_public_path__ + "static/media/2022_S_CP_Tradi_TI212_1couche_HD_01.4109ed19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2022_S_CP_Tradi_TI212_1couche_HD_01.jpg
// module id = 1156
// module chunks = 0